import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useDebounce from "shared/customHooks/useDebounce";
import { routeConstant } from "shared/routes/routesConstant";
import styles from "./style.module.scss";
import { Icons } from "assets";
import StatsCard from "shared/components/statsCard";
import AllBooksTable from "shared/components/projectHeadComponents/Books/allBooksTable";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";

let statsCard = [
  {
    label: "Total Books",
    count: 100,
    stats: {
      index: true,
      difference: "10%",
    },
  },
  {
    label: "Free Books",
    count: 50,
    stats: {
      index: false,
      difference: "2%",
    },
  },
  {
    label: "Premium Book",
    count: 1000,
    stats: {
      index: true,
      difference: "5%",
    },
  },
];

function PhNewBooksSummary() {
  useBreadcrumbs({
    title: "Books",
    path: routeConstant?.books_summary?.path,
  });
  return (
    <div className={styles.mainContainer}>
      <HeadingContainer />
      <StatsCard statsList={statsCard} label={"Books Stats"} />
      <AllBooksTable />
    </div>
  );
}

export default PhNewBooksSummary;

const HeadingContainer = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState<string>("");
  const [searchText, setSearchText] = useState<string>("");

  useDebounce(
    () => {
      setSearchText(search.trim());
    },
    [search],
    800
  );

  useEffect(() => {
    if (searchText?.length) {
      navigate({
        pathname: routeConstant.bookSearch.path,
        search: `?text=${searchText}`,
      });
    }
    // eslint-disable-next-line
  }, [searchText]);

  return (
    <div className={styles.mainContainer}>
      <Grid container>
        <Grid xs={12} md={6} sx={{ display: "flex", alignItems: "center" }}>
          <span className={styles.heading}>Manage Books Here</span>
        </Grid>
        <Grid xs={12} md={6}>
          <div className={styles.searchInputContainer}>
            <Icons.SearchIcon2 className={styles.searchIcon} />
            <input
              className={styles.seachInput}
              placeholder="Search book by Tittle, Keywords, Author or Publisher name"
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
